module.exports = __webpack_public_path__ + "img/gold-1.02a28863.png";